export default "__VITE_ASSET__DobCXwNI__"